export const makeOptionsApiEndpoints = () => {
  return {
    options: (orgId = ":orgId") => `/orgs/${orgId}/options`,
    userOptions: () => `/options`,
  }
}
